import {useHttpStore} from "~/composables/stores/http.store";
import {useDataStore} from "~/composables/stores/data.store";
import {useAdminDataStore} from "~/composables/stores/admin/adminData.store";
import type {components} from "#open-fetch-schemas/nest-main";

export const useAdminHttpStore = defineStore('adminHttp', () => {

    const {$nestMain} = useNuxtApp()
    const http = useHttpStore()
    const data = useDataStore()
    const adminData = useAdminDataStore()

    async function getCommonFilesPath(path?: string) {
        return await $nestMain('/admin/files/path', {query: {path: path}})
    }

    async function deleteFile(folderID: number) {
        return await $nestMain('/admin/files/delete/{id}', {
            method: 'DELETE',
            path: {id: folderID}
        })
    }

    async function renameFile(file: components['schemas']['ServerFileRenameOrMoveDTO']) {
        return await $nestMain('/admin/files/rename', {
            method: 'PUT',
            body: file
        })
    }

    async function uploadFilesR2(path: string | undefined, files: FileList, spin?: string) {
        return await $nestMain('/admin/files/upload-multiple-R2', {
            method: 'POST',
            body: {},
            query: {path: path, spin: spin},
            bodySerializer: (body) => {
                const formData = new FormData()
                for (let i of files) {
                    formData.append('files', i)
                }
                // for single file
                // formData.set('files', file)
                return formData
            }
        })
    }

    async function createCategory(categoryDTO: components['schemas']['CategoryDTO']) {
        return await $nestMain('/admin/category', {
            method: 'POST',
            body: categoryDTO
        })
    }

    async function editCategory(category: components['schemas']['Category']) {
        return await $nestMain('/admin/category', {
            method: 'PUT',
            body: category
        })
    }

    async function getProductSubTypes() {
        return await $nestMain('/admin/ProductSubType')
    }

    async function getCategoryWithParents(id: number) {
        return await $nestMain('/admin/CategoryWithParents/{id}', {path: {id: id}})
    }

    async function quickInput(body: components['schemas']['quickInputDTO']) {
        return await $nestMain('/admin/quickInput', {
            method: 'POST',
            body: body
        })
    }

    async function getStockPaginate() {
        return await $nestMain('/admin/stock')
    }

    async function getStockProductType(){
        return await $nestMain('/admin/stock/ProductType')
    }

    async function uploadToSirv(fileID: number) {
        return await $nestMain('/admin/files/uploadToSirv', {
            method: 'POST',
            query: {fileID: fileID}
        })
    }

    async function deleteFromSirv(fileID: number) {
        return await $nestMain('/admin/files/deleteFromSirv', {
            method: 'DELETE',
            query: {fileID: fileID}
        })
    }

    return {
        getCommonFilesPath, renameFile, deleteFile, getStockPaginate, getStockProductType,
        uploadFilesR2, uploadToSirv, deleteFromSirv,
        createCategory,
        editCategory, getProductSubTypes, getCategoryWithParents, quickInput
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAdminHttpStore, import.meta.hot))
}
